export const setActiveHeaderLink = (ref) => {
  if (!ref.headerDot) return;

  const [dot] = ref.headerDot;

  window.addEventListener("window-navigation", async () => {
    const res = await fetch("?section_id=site-header");
    const text = await res.text();
    const parser = new DOMParser();
    const markup = parser.parseFromString(text, "text/html");

    const newActive = markup.querySelector(".active") as HTMLAnchorElement;
    const oldActives = [
      ...ref.siteHeader[0].querySelectorAll(".active"),
      ...ref.headerMobileMenu[0].querySelectorAll(".active"),
    ];

    if (!newActive) return;

    const { pathname } = new URL(newActive.href);

    const targets = [
      ...ref.siteHeader[0].querySelectorAll(`[href="${pathname}"]`),
      ...ref.headerMobileMenu[0].querySelectorAll(`[href="${pathname}"]`),
    ];

    oldActives.forEach((link) => {
      link.classList.remove("active");
      if (isMobileLink(link)) {
        link.classList.remove(
          "flex",
          "gap-2",
          "items-center",
          "before:mt-2",
          "before:size-2",
          "before:bg-current",
          "before:rounded",
        );
      }
    });
    targets.forEach((link) => {
      if (link.id === "header-logo") return;
      link.classList.add("active");
      activate(link);
    });
  });

  // initial page load
  activate(ref.siteHeader[0].querySelector(".active"));

  function activate(link?) {
    if (!link) return;

    if (isMobileLink(link)) {
      link.classList.add(
        "flex",
        "gap-2",
        "items-center",
        "before:mt-2",
        "before:size-2",
        "before:bg-current",
        "before:rounded",
      );
    } else {
      const { left } = link.getBoundingClientRect();
      const { paddingLeft } = getComputedStyle(link);

      dot.style.transform = `translateX(calc(${left + parseFloat(paddingLeft)}px - 0.75rem))`;
      dot.style.opacity = 1;
    }
  }

  ref.headerLink.forEach((link) => {
    if (!isMobileLink(link)) {
      link.addEventListener("pointerover", () => activate(link));
      link.addEventListener("pointerdown", () => {
        dot.style.width = "0.33rem";
        dot.style.height = "0.33rem";
      });
      link.addEventListener("pointerup", () => {
        dot.style.removeProperty("width");
        dot.style.removeProperty("height");
      });
    }
  });

  ref.siteHeader[0].addEventListener("pointerleave", () => {
    activate(ref.siteHeader[0].querySelector(".active"));
  });

  function isMobileLink(link) {
    return !!link.closest("[data-mobile-menu]");
  }

  window.addEventListener("resize", () => {
    activate(ref.siteHeader[0].querySelector(".active"));
  });
};

// if this stays; add debounce
export const spinLogo = (ref) => {
  if (!ref.headerLogoSvg) return;

  function spin() {
    const duration = 400;

    ref.headerLogoSvg.forEach((el) => {
      el.style.transition = `scale ${duration}ms`;
      el.style.scale = "0.9";

      setTimeout(() => {
        el.style.transition = `scale ${duration / 3}ms`;
        el.style.scale = 1;
      }, duration);
    });
  }

  window.addEventListener("window-navigation", spin);
};

export const headerMobileMenuToggle = (ref) => {
  if (!ref.headerMobileMenuToggle) return;

  const [mobileMenu] = ref.headerMobileMenu;
  const drawer = mobileMenu.firstElementChild;

  let open = false;

  function toggleMenu(isOpen) {
    mobileMenu.classList.toggle("pointer-events-none", !isOpen);
    mobileMenu.classList.toggle("bg-black/50", isOpen);
    mobileMenu.classList.toggle("backdrop-blur-lg", isOpen);
    drawer.classList.toggle("translate-y-[140%]", !isOpen);
    drawer.classList.toggle("translate-y-0", isOpen);
  }

  ref.headerMobileMenuToggle[0].addEventListener("click", () => {
    open = !open;
    toggleMenu(open);
  });

  mobileMenu.addEventListener("click", (e) => {
    if ((e.target as HTMLElement).closest("[data-mobile-menu]")) return;
    open = false;
    toggleMenu(open);
  });

  window.addEventListener("window-navigation", () => {
    open = false;
    toggleMenu(open);
  });
};
